import { defineNuxtRouteMiddleware } from '#imports'

import { useHttpFromRoute } from './composables/useHttpFromRoute'
import { useLogger } from './composables/useLogger'

/**
 * Augment the logger context with information extracted from the route.
 * Owners are injected at the root level, while other HTTP information
 * is injected into the `http` property of each and every emitted logs.
 */
export default defineNuxtRouteMiddleware((route) => {
  const httpData = useHttpFromRoute(route)
  const { owners, ...http } = httpData

  useLogger().appendGlobalContext({
    ...(owners.length > 0 ? { owners } : {}),
    http,
  })
})
